// src/pages/profail/components/ProfailFields.js
import React from "react";
import { FaCheckSquare } from "react-icons/fa";


export default function ProfailFields({ editMode, draft, setDraft }) {
    const setField = (key, value) => {
        setDraft((prev) => ({ ...prev, [key]: value }));
    };

    const BASIC_ROWS = [
        { label: "Nama Masjid", key: "nama", readOnly: true, big: true },
        { label: "Poskod", key: "poskod" }, // manual input
        { label: "Alamat", key: "alamat" }, // manual input
        { label: "Bandar / Daerah", key: "bandar" }, // manual input
        { label: "Negeri", key: "negeri" }, // manual input
        { label: "No Telefon", key: "no_tel" },
        { label: "Emel", key: "emel", readOnly: true },
    ];




    return (
        <div className="pv2-block">
            {/* =========================
          Maklumat Asas
      ========================= */}
            {BASIC_ROWS.map((r) => {
                const value = draft?.[r.key] || "";

                return (
                    <div key={r.key} className="field-container">
                        <label className="field-label">{r.label}</label>

                        {!editMode ? (
                            <div className={`field-value ${r.big ? "nama" : ""}`}>
                                {value || "-"}
                            </div>
                        ) : (
                            <input
                                className="field-input"
                                value={value}
                                onChange={(e) => setField(r.key, e.target.value)}
                                readOnly={!!r.readOnly}
                                placeholder={r.readOnly ? "" : r.label}
                            />
                        )}
                    </div>
                );
            })}

            {/* =========================
          Hubungi, Media & Lokasi
      ========================= */}
            {/* <div className="field-container">
                <label className="field-label">Pilihan untuk dihubungi</label>
                {!editMode ? (
                    <div className="field-value">{draft?.contactPreferred || "whatsapp"}</div>
                ) : (
                    <select
                        className="field-input"
                        value={draft?.contactPreferred || "whatsapp"}
                        onChange={(e) => setField("contactPreferred", e.target.value)}
                    >
                        <option value="whatsapp">WhatsApp</option>
                        <option value="messenger">Messenger</option>
                    </select>
                )}
            </div> */}

            <div className="field-container">
                <label className="field-label">WhatsApp</label>
                {!editMode ? (
                    <div className="field-value">{draft?.no_whatsapp || "-"}</div>
                ) : (
                    <input
                        className="field-input"
                        value={draft?.no_whatsapp || ""}
                        onChange={(e) => setField("no_whatsapp", e.target.value)}
                        placeholder="contoh: 0123456789"
                    />
                )}
            </div>

            <div className="field-container">
                <label className="field-label">Facebook</label>
                {!editMode ? (
                    <div className="field-value-link">{draft?.facebook || "-"}</div>
                ) : (
                    <input
                        className="field-input"
                        value={draft?.facebook || ""}
                        onChange={(e) => setField("facebook", e.target.value)}
                        placeholder="contoh: https://facebook.com/masjidsaya"
                    />
                )}
            </div>



            <div className="field-container">
                <label className="field-label">Instagram</label>
                {!editMode ? (
                    <div className="field-value-link">{draft?.instagram || "-"}</div>
                ) : (
                    <input
                        className="field-input"
                        value={draft?.instagram || ""}
                        onChange={(e) => setField("instagram", e.target.value)}
                        placeholder="contoh: https://instagram.com/masjidsaya"
                    />
                )}
            </div>

            <div className="field-container">
                <label className="field-label">YouTube</label>
                {!editMode ? (
                    <div className="field-value-link">{draft?.youtube || "-"}</div>
                ) : (
                    <input
                        className="field-input"
                        value={draft?.youtube || ""}
                        onChange={(e) => setField("youtube", e.target.value)}
                        placeholder="contoh: https://youtube.com/@masjid"
                    />
                )}
            </div>

            <div className="field-container">
                <label className="field-label">Google Map</label>
                {!editMode ? (
                    <div className="field-value">
                        {draft?.gmaps ? (
                            <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                <FaCheckSquare />
                                Ada
                            </span>
                        ) : (
                            "-"
                        )}
                    </div>
                ) : (
                    <textarea
                        className="field-input"
                        value={draft?.gmaps || ""}
                        onChange={(e) => setField("gmaps", e.target.value)}
                        placeholder='paste iframe: <iframe src="https://www.google.com/maps/embed?..."></iframe>'
                        rows={3}
                    />
                )}
            </div>



        </div>
    );
}
